import { Component } from '@angular/core';
import { DeleteBase } from '../../../_classes/delete-base.class';
import ICalendarNote from '../../../_interfaces/ICalendarNote';
import { Observable } from 'rxjs';
import { CalendarNotesService } from '../../../_services/calendar-notes/calendar-notes.service';
import { SessionService } from '../../../_services/session/session.service';
import { ConfirmationService, MessageService } from 'primeng/api';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';
import { EResources } from '../../../_resources/EResources';

@Component({
  selector: 'app-delete-button-calendar-note',
  imports: [ButtonModule, TranslatePipe],
  templateUrl: './delete-button-calendar-note.component.html',
  styleUrl: './delete-button-calendar-note.component.scss',
})
export class DeleteButtonCalendarNoteComponent extends DeleteBase<ICalendarNote> {
  constructor(
    public session: SessionService,
    public confirm: ConfirmationService,
    public messageService: MessageService,
    public translate: TranslateService,
    public calendarNoteService: CalendarNotesService
  ) {
    super(session, confirm, messageService, translate);
  }

  delete(): Observable<any> {
    return this.calendarNoteService.remove(
      this.customers_id,
      this.sites_id,
      this.payload.id
    );
  }
  getResourceName(): string {
    return EResources.CALENDAR_NOTES;
  }
}
